<template>
  <div class="single-post-preview">
    <div class="blog-preview container">
      <div class="row">
        <div class="col col-8">
          <Breadcrumb :breadcrumb="blogBreadcrumb" class="blog-breadcrumb" />
          <h1 :class="{ 'blog-post-title-1': $store.state.layout === 'mobile' }">
            {{ page.title }}
          </h1>
          <div class="author-name">
            <template v-if="page.authorInfo.name">
              <nuxt-link class="author-link team" :to="page.authorInfo.authorSlug ? `/blog/authors/${page.authorInfo.authorSlug}/` : ''">
                <img :src="`${$config.imagesUrl}/team/thumb@128_${page.authorImage}`">
                <span><span v-if="$store.state.layout === 'mobile'">by </span><b>{{ page.authorInfo.name }}</b></span>
              </nuxt-link>
              <span class="bullet" />
            </template>
            <span :class="{ caption: $store.state.layout === 'mobile' }">{{ new Date(dateIsoString(page.updated)).toLocaleString("en-GB", { day: 'numeric', month: 'short', year: 'numeric' }) }}</span>
            <span class="bullet" />
            <span :class="{ caption: $store.state.layout === 'mobile' }">{{ page.readingTime }} min read</span>
            <template v-if="$store.getters['auth/perms'].includes('admin.blog') || $store.getters['auth/user'].role === 'admin'">
              <span class="bullet" />
              <span>
                <a
                  :href="`${$config.lmsUrl}/admin/blog/edit/${page.parentId || page.id}`"
                  class=""
                  target="_blank"
                >
                  Edit <IconEdit />
                </a>
              </span>
            </template>
          </div>
          <article class="article-content" v-html="blogContent" />
          <div class="try-banner">
            <p class="h4">
              Learn data science with industry experts
            </p>
            <template v-if="$store.state.layout === 'mobile' && !$store.state.tablet">
              <p>Comprehensive training, exams, certificates. Find your dream job.</p>
              <img loading="lazy" src="../../assets/images/blog-banner-users-mobile.png">
            </template>
            <nuxt-link to="/signup/" class="btn-primary" data-event="startforfree.click">
              Try For Free
            </nuxt-link>
            <div v-if="$store.state.layout === 'mobile' && !$store.state.tablet" class="rating-holder">
              <Rating :scale="4.5" />
              <span class="text">
                <strong>413,000+</strong> Reviews
              </span>
            </div>
          </div>
          <div v-if="page.authorInfo.name" class="author">
            <div class="authot-avatar">
              <img loading="lazy" :src="`${$config.imagesUrl}/team/thumb@128_${page.authorImage}`">
            </div>
            <div class="author-info">
              <p class="h6">
                <nuxt-link class="author-link" :to="page.authorInfo.authorSlug ? `/blog/authors/${page.authorInfo.authorSlug}/` : ''">
                  {{ page.authorInfo.name }}
                </nuxt-link>
                <a
                  v-if="page.authorInfo.linkedin"
                  class="linkedin-link" :href="page.authorInfo.linkedin" target="_blank"
                  rel="noopener"
                >
                  <IconLinkedin />
                </a>
              </p>
              <p class="caption">
                {{ page.authorInfo.authorTitle }}
              </p>
              <p class="body-2">
                <span v-html="page.authorInfo.authorDescription" />
              </p>
            </div>
          </div>
          <div v-if="relatedPosts.length" class="related-posts">
            <p class="h3">
              We Think you'll also like
            </p>
            <ArticleCard
              v-for="(item, k) in relatedPosts" :key="k" :article="item"
              type="horizontal" article-type="related-posts"
              heading="p"
            />
          </div>
        </div>
        <div class="col" :class="{ 'col-4': $store.state.layout !== 'mobile' }">
          <div class="similar-posts">
            <p class="h4">
              Similar Posts
            </p>
            <nuxt-link
              v-for="(article, k) in similarPosts" :key="k" class="similar-post"
              :to="blogPostURL(article)"
              data-event="similar_posts.click"
            >
              <img
                loading="lazy"
                class="article-image" :src="`${$config.imagesUrl}/blog/thumb@520_${article.image}`"
                alt="Article image"
              >
              <p>{{ article.title }}</p>
            </nuxt-link>
          </div>
          <div v-if="$config.campaign === 'free'" class="learn-free">
            <div class="courses">
              ALL COURSES
            </div>
            <div class="free">
              FREE
            </div>
            <div class="days">
              <span>for</span>21<span>days</span>
            </div>
            <nuxt-link to="/signup/" class="btn-primary btn-lg">
              Start Now
            </nuxt-link>
          </div>
          <div v-else-if="$config.campaign === 'black-friday'" class="learn-bf learn-ds">
            <div class="campaign">
              BLACK FRIDAY
            </div>
            <BlackFridayFonts :class-name="'blog'" :words="['72%']" />
            <p class="off">
              OFF
            </p>
            <nuxt-link :to="'/black-friday-2022/'" class="btn-primary btn-lg">
              GET NOW
            </nuxt-link>
          </div>
          <div v-else-if="$config.campaign === 'cyber-monday'" class="learn-cm">
            <img class="background-img" src="../../assets/images/cm-banners/cyber-monday-blog-banner.png">
            <div class="cm-campaign">
              CYBER MONDAY
            </div>
            <div class="font-wrapper">
              <div class="cm-font-wrapper cm-fonts">
                <div campaign="72%" class="top-side">
                  72%
                </div>
                <div campaign="72%" class="bottom-side">
                  72%
                </div>
              </div>
              <p class="cm-off">
                OFF
              </p>
            </div>
            <nuxt-link :to="'/cyber-monday-2022/'" class="btn-primary btn-lg btn-cm">
              GET NOW
            </nuxt-link>
            <img class="bg-visual-1" src="../../assets/images/cm-banners/cm-blog-banner-visuals-1.png">
            <img class="bg-visual-2" src="../../assets/images/cm-banners/cm-blog-banner-visuals-2.png">
            <img class="bg-visual-3" src="../../assets/images/cm-banners/cm-blog-banner-visuals-3.png">
            <img class="bg-visual-4" src="../../assets/images/cm-banners/cm-blog-banner-visuals-4.png">
          </div>
          <div v-else-if="$config.campaign === 'jumpstart'" class="jumpstart">
            <div class="main">
              {{ jumpstartBanner.title }}
            </div>
            <div class="with">
              {{ jumpstartBanner.subtitle }}
            </div>
            <div class="special">
              {{ jumpstartBanner.subtitle2 }}
            </div>
            <div class="discounts">
              {{ jumpstartBanner.subtitle3 }}
            </div>
            <nuxt-link :to="'/jumpstart-2023/'" class="btn-primary btn-lg">
              {{ jumpstartBanner.btn }}
            </nuxt-link>
          </div>
          <div v-else-if="$config.campaign === 'got-what-it-takes'" class="got-what-it-takes">
            <p class="campaign-title">
              <span class="highlighted-left">GOT WHAT</span>
              <span class="highlighted-right">IT TAKES?</span>
            </p>
            <p class="promo-subtitle">
              Master Data Science at <span class="highlighted">65% off</span>
            </p>
            <nuxt-link :to="'/got-what-it-takes/'" class="btn-primary btn-got-what-it-takes">
              Save Now
            </nuxt-link>
          </div>
          <div v-else-if="$store.state.campaign === 'one-of-two-hundred'" class="one-of-two-hundred">
            <div class="title">
              <span class="first-line">GRAB <span class="highlighted">1 OF 200</span></span>
              <span class="second-line">SPECIAL-PRICE</span>
              <span class="third-line">ANNUAL PLANS</span>
            </div>
            <nuxt-link :to="'/one-of-two-hundred/'" class="btn-primary btn-one-of-two-hundred">
              Grab {{ oneof200Banner.discount }}% OFF
            </nuxt-link>
          </div>
          <div v-else-if="$store.state.layout !== 'mobile'" class="learn-ds">
            <p class="h4">
              Learn data science with industry experts
            </p>
            <p class="body-1">
              Comprehensive training, exams, certificates. Find your dream job.
            </p>
            <img loading="lazy" src="../../assets/images/blog-banner-users-light.png">
            <nuxt-link to="/signup/" class="btn-primary btn-lg col-9">
              Start your career
            </nuxt-link>
            <div class="rating-holder">
              <Rating :scale="4.5" />
              <span class="text">
                <strong>413,000+</strong> Reviews
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a
      class="up-arrow-btn"
      :class="{ 'visible': scrolled }"
      @click="scrollToTop"
    >
      <UpArrow />Top
    </a>
  </div>
</template>

<script>
import moment from 'moment';
import jsonld from '@itbpbg/lms-components/src/utils/json-ld-ds';
import global from '@itbpbg/lms-components/src/mixins/global';
import Breadcrumb from '@itbpbg/lms-components/src/components/Breadcrumb';
import { CAMPAIGN_PROMOTIONS } from '@itbpbg/lms-components/src/utils/constants';
import 'highlight.js/styles/github.css';
import hljs from 'highlight.js';
import axios from 'axios';
import IconLinkedin from '@itbpbg/lms-components/src/assets/svg/icon-site-linkedin.svg?vue-component';
import BlackFridayFonts from '@itbpbg/lms-components/src/components/BlackFridayFonts';
import ArticleCard from './ArticleCard';
import UpArrow from '../../assets/svg/icon-arrow-blog-up.svg?vue-component';
import IconEdit from '../../assets/svg/icon-blog-edit.svg?vue-component';
import Rating from '../Rating';

export default {
  components: {
    Breadcrumb, UpArrow, ArticleCard, Rating, IconEdit, IconLinkedin, BlackFridayFonts,
  },
  mixins: [global],
  scrollToTop: true,
  props: {
    page: { type: Object, required: true },
  },
  data: () => ({
    blogBreadcrumb: [],
    comments: false,
    metaFullImageUrl: '',
    regExpVideo: /(<iframe.+?youtube.+?<\/iframe>)/gm,
    content: '',
    videosList: null,
    imagesList: null,
    scrolled: false,
  }),
  async fetch() {
    this.videosList = await this.generateVideosList(this.page.content);
    this.imagesList = await this.generateImagesList(this.page.content);
  },
  head() {
    this.blogBreadcrumb = this.breadcrumb(this.page, 'blog');
    this.metaFullImageUrl = `${this.$config.imagesUrl}/blog/${this.page.metaImage}`;

    const datePublished = this.dateIsoString(this.page.created);
    const dateModified = this.dateIsoString(this.page.updated);
    const searchAction = jsonld.PotentialActions.search;
    searchAction.target = [`${this.$config.siteUrl}/blog/search?q={search_term_string}`];

    const seoWebPage = {
      ...jsonld.WebPage,
      url: `${this.$config.siteUrl}${this.$route.fullPath}`,
      name: this.page.metaTitle,
      description: this.page.metaDescription,
      datePublished,
      dateModified,
      potentialAction: [searchAction],
    };

    const seoWebSite = { ...jsonld.WebSite };

    const seoImageObject = {
      ...jsonld.ImageObject,
      '@id': this.page.image,
      url: this.metaFullImageUrl,
      width: this.page.metaImageWidth,
      height: this.page.metaImageHeight,
      caption: this.page.title,
    };

    const seoArticle = {
      ...jsonld.Article,
      '@id': `${this.$config.siteUrl}${this.$route.fullPath}#article`,
      isPartOf: `${this.$config.siteUrl}${this.$route.fullPath}#webpage`,
      headline: this.page.title,
      keywords: this.page.metaKeywords,
      image: {
        ...jsonld.Article.image,
        '@id': this.page.image,
      },
      datePublished,
      dateModified,
      mainEntityOfPage: `${this.$config.siteUrl}${this.$route.fullPath}#article`,
      potentialAction: { ...jsonld.PotentialActions.consume.read, target: [`${this.$config.siteUrl}${this.$route.fullPath}`] },
      video: [],
      author: {
        ...jsonld.Person,
        name: this.page.authorInfo.name,
        image: {
          ...jsonld.ImageObject,
          '@id': `${this.$config.imagesUrl}/team/thumb@128_${this.page.authorImage}`,
        },
      },
    };

    if (this.videosList && this.videosList.itemListElement) {
      seoArticle.video.push(...this.videosList.itemListElement);
    }

    const jsonData = [
      {
        '@context': 'https://schema.org',
        '@graph': [seoWebSite, seoImageObject, seoWebPage, seoArticle],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: jsonld.JSONBreadcrumb(this.blogBreadcrumb, this.$config.siteUrl),
      },
    ];

    if (this.imagesList) jsonData[0]['@graph'].push(this.imagesList);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.page.canonicalUrl || this.canonicalURL() },
      ],
      meta: this.metaProps({ ...this.page, isBlog: true }),
      script: [
        { src: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=TeX-MML-AM_CHTML', async: true },
        {
          vmid: 'jsonld',
          type: 'application/ld+json',
          json: jsonData,
        },
      ],
    };
  },
  computed: {
    blogContent() {
      return this.content;
    },
    relatedPosts() {
      return this.page.relatedPosts.slice(4);
    },
    similarPosts() {
      return this.page.relatedPosts.slice(0, 4);
    },
    jumpstartBanner() {
      const utcPromoEndDate = moment.utc('January 29, 2023 15:00:00');
      const localPromoEndDate = new Date(utcPromoEndDate);
      const currentLocaldate = new Date();
      let obj = {
        title: 'JUMPSTART 2023',
        subtitle: 'WITH',
        subtitle2: 'SPECIAL',
        subtitle3: 'DISCOUNTS',
        btn: 'Save Now',
      };

      if (currentLocaldate.getTime() > localPromoEndDate.getTime()) {
        obj = {
          title: 'LAST CHANCE',
          subtitle: 'for a',
          subtitle2: 'SPECIAL',
          subtitle3: 'DISCOUNT',
          btn: 'Grab Now',
        };
      }

      return obj;
    },
    oneof200Banner() {
      const promotions = CAMPAIGN_PROMOTIONS['one-of-two-hundred'];
      // eslint-disable-next-line no-restricted-syntax
      for (const promotion of promotions) {
        const endDateUtc = moment.utc(promotion.endDate);
        const localCountDownDate = new Date(endDateUtc);
        if (new Date() < new Date(localCountDownDate)) {
          return { discount: promotion.discount };
        }
      }
      return { discount: 62 };
    },
  },
  created() {
    /*
    unescape on content removed - ref. https://github.com/itbpbg/lms-site/issues/564 - after some research, we don't render MathML tags anymore.
    */
    this.content = this.page.content // unescape - for MathML decode the content
      // .replace(/(src="https:\/\/365datascience\.com\/resources\/blog\/)(.+?\.)/g, (m0, m1, m2) => `${m1}thumb@1024_${m2}`) // thumb replacer
      .replace(/(src="https:\/\/365datascience\.com\/resources\/blog\/)(.+?)\..+?"/g, (m0, m1, m2) => `${m1}thumb@1024_${m2}.webp"`)
      .replace(this.regExpVideo, (m) => `<div class="iframe-video">${m}</div>`); // set wrapper for embed videos
    // return content.replace(/<br \/>&nbsp;/g, '').replace(/<p>(.+?)<\/p>/gm, ($1, $2) => $2); // also remove all '<br />&nbsp' strings.
    this.handleScroll();
  },
  mounted() {
    if (window.MathJax) {
      this.$nextTick(() => {
        window.MathJax.Hub.Config({
          tex2jax: {
            inlineMath: [['$', '$'], ['\\(', '\\)']],
            processEscapes: true,
          },
          'HTML-CSS': {
            linebreaks: { automatic: true, width: 'container' },
          },
        });
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      });
    }
    this.$nextTick(() => {
      document.querySelectorAll('.article-content h1, h2, h3, h4, h5, h6').forEach((heading) => {
        const headingNumber = heading.id;
        heading.classList.add(`blog-post-title-${headingNumber || 0}`);
      });
      document.querySelectorAll('.faq-section .question').forEach((q) => {
        // eslint-disable-next-line no-param-reassign
        q.querySelector('.question-text strong').outerHTML += `<svg class="arrow" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>`;
        q.querySelector('.question-text').addEventListener('click', this.handleFAQ, false);
      });
      document.querySelectorAll('p').forEach((p) => {
        if (p.textContent.trim() === '' && !p.querySelector('.image-lightbox')) {
          // eslint-disable-next-line no-param-reassign
          p.style.display = 'none';
        }
      });
    });
    const codeBlocks = document.querySelectorAll('pre code');
    if (codeBlocks.length) {
      codeBlocks.forEach((block) => {
        hljs.highlightElement(block);
      });
    }
    this.lightBox(this.$el.querySelectorAll('.article-content'));
  },
  methods: {
    handleFAQ(e) {
      const question = e.target.closest('.question');
      if (!question.classList.contains('open')) {
        question.classList.add('open');
      } else {
        question.classList.remove('open');
      }
    },
    async generateVideosList(blogContent) {
      const regex = /<iframe.+?src=".+?youtube.+?\/embed\/(.+?)(\?.+?)*"/gm;
      const matches = [...blogContent.matchAll(regex)];
      const videosList = [];
      if (matches.length) {
        const videoIDs = matches.map((v) => v[1]);
        // eslint-disable-next-line no-restricted-syntax
        for await (const v of videoIDs) {
          const { data } = await axios.get(`https://www.googleapis.com/youtube/v3/videos?part=snippet,contentDetails,statistics&id=${v}&key=AIzaSyAiasw0Pl11H-zSvaVWgei5NIDDGpz4Kdw`);
          if (data.items.length && data.items[0]) {
            const {
              contentDetails: { duration },
              snippet: {
                publishedAt, title, description, thumbnails: { maxres, high },
              },
              statistics: { viewCount },
            } = data.items[0];
            const videoObject = {
              ...jsonld.VideoObject,
              name: this.removeTags(title),
              description: this.removeTags(description),
              thumbnailUrl: maxres ? maxres.url : high.url,
              uploadDate: publishedAt,
              interactionStatistic: {
                '@type': 'InteractionCounter',
                interactionType: { '@type': 'http://schema.org/WatchAction' },
                userInteractionCount: viewCount,
              },
              duration,
              embedUrl: `https://www.youtube.com/embed/${v}`,
            };
            videosList.push(videoObject);
          }
        }
        return {
          ...jsonld.ItemList,
          itemListElement: videosList,
        };
      }
      return null;
    },
    generateImagesList(blogContent) {
      const regex = /<img.+?src="(.+?)(\?.+?)*"/gm;
      const matches = [...blogContent.matchAll(regex)];
      if (matches.length) {
        const imagesList = [];
        const urls = matches.map((v) => v[1]);
        urls.forEach((url, index) => {
          const imageObject = {
            ...jsonld.ImageObject,
            '@id': url,
            url,
            position: index,
            height: '',
            width: '',
          };
          imagesList.push(imageObject);
        });
        return {
          ...jsonld.ItemList,
          itemListElement: imagesList,
        };
      }
      return null;
    },
    scrollToTop() {
      if (process.client) {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      }
    },
    handleScroll() {
      if (process.client) {
        window.onscroll = () => {
          this.scrolled = window.scrollY > 0 && this.$store.state.layout === 'desktop';
        };
      }
    },
  },
};
</script>

<style lang="scss">
.single-post-preview {
  padding-top: 180px;

  .blog-preview {
    h1 {
      margin: var(--spacing-48) 0 var(--spacing-36);
    }

    .author-name {
      display: flex;
      align-items: center;
      margin-bottom: var(--spacing-60);

      span {
        color: var(--main-dark-shade-3);

        &.bullet {
          background: var(--main-dark-shade-3);
          height: 4px;
          width: 4px;
          border-radius: 50%;
          margin: 0 var(--spacing-xs);
        }

        b {
          color: var(--main-dark-shade-0);
          font-weight: 500;
        }
      }

      .team {
        display: flex;
        align-items: center;

        img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          margin-right: var(--spacing-12);
          object-fit: cover;
          object-position: center;
        }
      }
    }

    .article-content {
      margin-top: var(--spacing-24);
      color: var(--black);
      font-family: var(--base-font);
      font-size: var(--fs-base);
      line-height: var(--base-line-height);

      table {
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
        display: flex;
      }

      img {
        max-width: 100%;
        width: auto !important;
        height: auto !important;
        display: block;
        margin-left: auto;
        margin-right: auto;

        [style~="float: left"] {
          margin-left: 0;
          margin-right: auto;
        }

        [style~="float: right"] {
          margin-left: auto;
          margin-right: 0;
        }

        &.no-lightbox {
          width: auto !important;
          height: auto !important;
          max-width: 100%;
        }
      }

      .mjx-chtml { white-space: break-spaces; }

      *[id] {
        &:target {
          &:before {
            content: '';
            display: block;
            height: 155px;
            margin-top: -155px;
          }
        }

        @include bp($bp-mobile) {
          &:target {
            &:before {
              content: '';
              display: block;
              height: 65px;
              margin-top: -65px;
            }
          }
        }
      }

      p {
        font-size: 18px;
        line-height: 150%;
        color: var(--main-dark-shade-1);
        letter-spacing: normal;
      }

      .image-lightbox {
        margin: var(--spacing-24) auto var(--spacing-24);
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-weight: 500;
        color: var(--main-dark-shade-0);
        margin-top: var(--spacing-48);
      }

      h1 {
        margin-bottom: var(--spacing-36);
      }

      h2 {
        margin-bottom: var(--spacing-24);
      }

      h3 {
        margin-bottom: var(--spacing-20);
      }

      h4 {
        margin-bottom: var(--spacing-18);
      }

      ol {
        margin-left: 0;
        padding-left: var(--spacing-24);
        list-style-position: inside !important;

        li {
          margin-bottom: var(--spacing-16);
          letter-spacing: normal;
          font-size: 18px;
          line-height: 150%;
        }
      }

      ul {
        margin-left: 0;
        padding-left: var(--spacing-24);
        list-style: none !important;

        li {
          margin-bottom: var(--spacing-16);
          letter-spacing: normal;
          font-size: 18px;
          line-height: 150%;

          &:before {
            content: "";
            background: var(--accent-shade-1);
            font-weight: bold;
            display: inline-block;
            width: 8px;
            height: 8px;
            margin-right: var(--spacing-16);
          }
        }
      }

      a {
        color: var(--accent-shade-2);
        text-decoration: underline;

        &:hover {
          color: var(--accent-shade-1);
        }

        &.orange-button {
          color: var(--true-white);
          text-decoration: none;
          padding: 20px;
        }
      }

      blockquote {
        font-size: 21px;
        line-height: 33.6px;
        position: relative;
        background: var(--main-light-shade-2);
        border-radius: 9px;
        padding: 55px var(--spacing-48) var(--spacing-12);
        margin: 0 0 var(--spacing-48) 0;

        *:not(.blockquote-author) {
          font-size: 21px;
          line-height: 34px;
          margin: 0 0 var(--spacing-16);
          font-weight: normal;
          text-transform: unset;
          color: var(--main-dark-shade-1);
        }

        &:before {
          content: '';
          background-image: url('../../assets/images/icon-quotes.png');
          image-rendering: -webkit-optimize-contrast;
          background-repeat: no-repeat;
          position: absolute;
          top: 30px;
          width: 24px;
          height: 19px;
        }

        .blockquote-author {
          font-weight: 500;
          font-size: 18px;
          line-height: 110%;
          margin-top: 24px;
        }
      }

      .iframe-video {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;

        iframe {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border-radius: 10px;
        }
      }

      .questions-wrap {
        .question {
          border-bottom: 1px solid rgba(0, 12, 31, 0.12);
          box-sizing: border-box;
          color: var(--main-dark-shade-0);
          display: grid;
          overflow: hidden;
          position: relative;
          transition: all 200ms ease-in-out;

          .question-text {
            display: flex;
            justify-content: space-between;
            padding: var(--spacing-24) 0;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            transition: all 250ms ease-in-out;
            position: relative;

            .arrow {
              position: absolute;
              right: 0;
              top: var(--spacing-24);
              transition: all 250ms ease-in-out;
            }
          }

          &.open {
            padding-bottom: var(--spacing-24);

            .question-text .arrow {
              transform: rotateZ(90deg);
            }

            .answer {
              color: var(--main-dark-light-3);
              max-height: 9999px;
              transition: max-height 1s ease-in-out;
              overflow: hidden;
            }
          }

          .answer {
            color: var(--main-dark-light-3);
            max-height: 0;
            transition: all 500ms cubic-bezier(0, 1, 0, 1);

            a {
              color: var(--accent);
            }
          }
        }
      }
    }

    .try-banner {
      position: relative;
      background-color: var(--main-dark-shade-1);
      background-image: url('../../assets/images/blog-banner-users.png');
      image-rendering: -webkit-optimize-contrast;
      background-position: right;
      background-repeat: no-repeat;
      border-radius: 7px;
      margin-top: var(--spacing-48);
      margin-bottom: var(--spacing-80);
      height: 216px;
      padding: 40px 48px;

      .h4 {
        width: 50%;
        color: var(--main-light);
        margin-bottom: var(--spacing-36);
      }

      &:before {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: var(--spacing-80);
        background: linear-gradient(270deg, var(--main-dark-shade-1) 0%, rgba(20, 31, 49, 0.9) 24.26%, rgba(20, 31, 49, 0) 100%);
        border-radius: 7px;
      }
    }

    .author {
      border-top: 1px solid var(--main-light-shade-3);
      padding-top: var(--spacing-36);
      margin: 0 0 var(--spacing-80) 0;
      display: flex;

      .authot-avatar {
        margin-right: var(--spacing-30);

        img {
          border-radius: 50%;
          height: 67px;
          position: relative;
          overflow: hidden;
          width: 67px;
          object-fit: cover;
          object-position: center;
        }
      }

      .author-info {
        .h6 {
          margin-bottom: var(--spacing-4);
          display: flex;
          align-items: center;
        }

        .author-link {
          color: var(--main-dark-shade-0);

          &:hover {
            color: var(--accent);
          }
        }

        .linkedin-link {
          display: flex;

          svg {
            width: 18px;
            height: 18px;
            background: #0A7ED4;
            color: var(--main-light);
            padding: 2px;
            margin-left: var(--spacing-8);
            border-radius: 2px;
          }

          &:hover {
            color: var(--main-light);

            svg {
              transform: scale(1.1);
            }
          }
        }

        .caption {
          font-weight: 500;
          color: var(--accent-shade-2);
          margin: 0 0 var(--spacing-16);
        }

        .body-2 {
          margin: 0;
        }
      }
    }

    .related-posts {
      .h3 {
        margin: 0;
        padding-bottom: var(--spacing-12);
        text-transform: capitalize;
      }

      .list .article .instructor .caption b {
        color: var(--main-dark-shade-0);
      }
    }

    .similar-posts {
      margin-bottom: var(--spacing-60);

      .similar-post {
        display: flex;
        align-items: center;
        margin-top: var(--spacing-24);

        img {
          max-width: 120px;
          height: 72px;
          width: 100%;
          border-radius: 3px;
          object-fit: cover;
          object-position: center;
        }

        p {
          font-weight: 500;
          line-height: 110%;
          text-transform: capitalize;
          color: var(--main-dark-shade-0);
          margin: 0 0 0 var(--spacing-16);
        }
      }
    }

    .learn-free,
    .learn-ds {
      padding: var(--spacing-36) var(--spacing-30);
      text-align: center;
    }

    .learn-free {
      background: var(--main-dark);
      border-radius: 10px;

      .courses {
        font-size: 40px;
        line-height: 42px;
        font-weight: 700;
        padding: 0 20px;
      }

      .free {
        font-size: 105px;
        line-height: 124px;
        color: var(--extreme-blue);
        font-weight: 600;
        position: relative;
        margin-bottom: var(--spacing-4);
        display: inline-block;

        &:after {
          content: "FREE";
          position: absolute;
          top: 4px;
          color: transparent;
          -webkit-text-stroke: 1px var(--extreme-blue);
          left: 8px;
        }
      }

      .days {
        font-size: 54px;
        line-height: 64px;
        font-weight: 800;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          font-weight: 500;
          font-size: 20px;
          color: var(--main-light-shade-4);
        }

        span:first-of-type {
          margin-right: 4px;
        }

        span:last-of-type {
          margin-left: 4px;
        }
      }

      .btn-primary {
        background: var(--main-yellow);
        border-color: transparent;
        color: var(--main-dark-shade-0);
        font-weight: 600;
        width: 100%;
        margin-top: var(--spacing-24);

        &:hover {
          background: var(--main-yellow-shade-2);
        }
      }
    }

    .learn-ds {
      background: var(--main-light-shade-2);
      border-radius: 10px;

      .h4 {
        text-transform: capitalize;
      }

      .body-1 {
        color: var(--main-dark-shade-3);
        margin-bottom: 36px;
      }

      .btn-primary {
        margin-top: var(--spacing-36);
        margin-bottom: var(--spacing-16);
        width: 100%;
        max-width: 270px;
      }

      .rating-holder {
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          color: var(--main-dark-light-3);
          line-height: 140%;
        }

        .rating {
          svg.half {
            path.second-half {
              fill: var(--main-light-shade-4) !important;
            }
          }
        }
      }
    }

    .learn-bf {
      background-image: url('../../assets/images/bf-landing/blog-banner.png');

      .campaign {
        font-weight: 900;
        font-size: 39px;
      }

      .off {
        margin: 0;
        float: right;
        font-weight: 700;
        font-size: 48px;
        letter-spacing: 0.05em;
      }

      .btn-primary {
        border: 0;
        border-radius: 0;
        background: var(--extreme-yellow);
        color: var(--main-dark-shade-0);
        font-weight: 600;
        margin: var(--spacing-16) 0;
      }
    }

    .learn-cm {
      position: relative;
      display: flex;
      flex-direction: column;
      align-content: center;
      align-items: center;
      flex-wrap: wrap;

      .background-img {
        width: 100%;
      }

      .cm-campaign {
        font-weight: 900;
        font-size: 36px;
        line-height: 42px;
        color: var(--extreme-blue);
        text-shadow: 0 2px 5px rgba(37, 244, 238, 0.5), 1.5px 5px 8px #2D0CEC;
        position: absolute;
        top: 50px;
      }

      .font-wrapper {
        background-image:
          linear-gradient(var(--extreme-yellow), var(--extreme-yellow)),
          linear-gradient(var(--extreme-yellow), var(--extreme-yellow)),
          linear-gradient(var(--extreme-yellow), var(--extreme-yellow)),
          linear-gradient(var(--extreme-yellow), var(--extreme-yellow));
        background-repeat: no-repeat;
        background-size: 27px 3px;
        background-position: top left, top right, bottom left, bottom right;
        border: solid var(--extreme-yellow);
        border-width: 0 3px;
        width: 290px;
        position: absolute;
        top: 110px;
        display: flex;
        flex-direction: column;

        .cm-fonts {
          margin: auto;
          text-align: center;
          filter: drop-shadow(0 0 10px #195FF5);
          width: 260px;
          line-height: 120px;
          height: 120px;

          .top-side,
          .bottom-side {
            font-weight: 800;
            font-size: 130px;
            color: var(--extreme-blue);
            position: relative;
            top: 0;
            left: 0;
            text-shadow: 2px 2px #142251;
          }

          .top-side:after,
          .bottom-side:after {
            content: attr(campaign);
            font-size: 130px;
            font-weight: 800;
            color: var(--extreme-fucsia);
            top: -3px;
            left: 3px;
            position: absolute;
            mix-blend-mode: screen;
            text-shadow: 2px 2px #142251;
          }

          .top-side {
            clip-path: inset(0 0 53% 0);
            left: 3px;
            top: 6px;
          }

          .bottom-side {
            clip-path: inset(45% 0 0 0);
            top: -114px;
          }
        }

        .cm-off {
          font-weight: 700;
          font-size: 47px;
          line-height: 55px;
          letter-spacing: 0.05em;
          color: var(--extreme-yellow);
          margin: 0;
          padding-left: var(--spacing-16);
        }
      }

      .btn-cm {
        border-bottom: 8px solid #020C20;
        border-radius: 0;
        background: var(--extreme-yellow);
        color: var(--main-dark-shade-0);
        font-weight: 600;
        margin: var(--spacing-16) 0;
        width: 290px;
        position: absolute;
        top: 290px;
      }

      .bg-visual-1 {
        position: absolute;
        top: 169px;
        left: 49px;
      }

      .bg-visual-2 {
        position: absolute;
        top: 240px;
        left: 170px;
      }

      .bg-visual-3 {
        position: absolute;
        top: 260px;
        left: 164px;
      }

      .bg-visual-4 {
        position: absolute;
        top: 160px;
        right: 0;
      }
    }

    .jumpstart {
      background-image: url('../../assets/images/jumpstart-2023-landing/jumpstart-blog-banner.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      text-align: center;
      color: var(--main-light);
      border-radius: 10px;
      height: 395px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 345px;

      .main {
        font-weight: 900;
        font-size: 32px;
        line-height: 38px;
        text-shadow: 0 3.47052px 8.42841px rgba(37, 244, 238, 0.5), 0 0 13.8821px rgba(25, 245, 238, 0.5);
      }

      .with {
        font-weight: 400;
        font-size: 24px;
      }

      .special {
        color: var(--extreme-blue);
        font-weight: 900;
        font-size: 49.7778px;
        line-height: 59px;
        text-shadow: 0 2.10464px 5.11128px rgba(37, 244, 238, 0.5), 0 0 8.41857px rgba(25, 245, 238, 0.5);
      }

      .discounts {
        color: var(--extreme-blue);
        font-weight: 900;
        font-size: 36.56px;
        line-height: 43.21px;
        text-shadow: 0 2.10464px 5.11128px rgba(37, 244, 238, 0.5), 0 0 8.41857px rgba(25, 245, 238, 0.5);
      }

      .btn-primary {
        color: var(--main-dark);
        background-color: var(--main-yellow);
        border: none;
        width: 100%;
        max-width: 270px;
        margin-top: 28px;

        &:hover {
          background-color: var(--main-yellow-shade-1);
        }

        &:active {
          background-color: var(--main-yellow-shade-2);
        }
      }
    }

    .got-what-it-takes {
      background-image: url('../../assets/images/got-what-it-takes-landing/gwt-blog-banner-bg.jpg');
      max-width: 345px;
      height: 395px;
      padding: var(--spacing-70) var(--spacing-30);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      text-align: center;
      color: var(--main-light);
      border-radius: 10px;

      .campaign-title {
        position: relative;
        height: 119px;
        padding-left: 0;
        margin: 0;

        .highlighted-left {
          padding-left: var(--spacing-8);
          position: absolute;
          top: 3px;
          left: 50%;
          transform: translateX(-50%);
          height: 54px;
          width: 100%;
          font-weight: 700;
          line-height: 110%;
          font-size: 49px;
          display: block;
          text-shadow:
            0 0 0 #3DAFB8,
            -1px 1px 0 #3DAFB8,
            -2px 2px 0 #3DAFB8,
            -3px 3px 0 #3DAFB8,
            -4px 4px 0 #3DAFB8,
            -5px 5px 0 #3DAFB8,
            -6px 6px 0 #3DAFB8,
            -7px 7px 0 #3DAFB8,
            -8px 8px 0 #3DAFB8,
            -9px 9px 0 #3DAFB8,
            -10px 10px 0 #3DAFB8,
            -11px 11px 0 #3DAFB8;
        }

        .highlighted-right {
          padding-left: var(--spacing-8);
          position: absolute;
          top: 63px;
          left: 50%;
          transform: translateX(-50%);
          height: 61px;
          width: 100%;
          font-size: 56px;
          font-weight: 700;
          line-height: 110%;
          display: block;
          text-shadow:
            0 0 0 #CEA40A,
            -1px 1px 0 #CEA40A,
            -2px 2px 0 #CEA40A,
            -3px 3px 0 #CEA40A,
            -4px 4px 0 #CEA40A,
            -5px 5px 0 #CEA40A,
            -6px 6px 0 #CEA40A,
            -7px 7px 0 #CEA40A,
            -8px 8px 0 #CEA40A,
            -9px 9px 0 #CEA40A,
            -10px 10px 0 #CEA40A,
            -11px 11px 0 #CEA40A;
        }
      }

      .promo-subtitle {
        display: block;
        padding: 0 var(--spacing-16);
        margin-top: var(--spacing-12);
        margin-bottom: var(--spacing-16);
        font-weight: 500;
        font-size: 24px;
        line-height: 110%;

        .highlighted {
          font-weight: 800;
          color: var(--accent);
        }
      }

      .btn-got-what-it-takes {
        width: 270px;
        height: 56px;
        margin: 0 auto;
        background: var(--main-yellow);
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
        letter-spacing: 0.02em;
        color: var(--main-dark);

        &:hover {
          background-color: var(--main-yellow-shade-1);
        }

        &:active {
          background-color: var(--main-yellow-shade-2);
        }
      }
    }

    .one-of-two-hundred {
      background-image: url('../../assets/images/one-of-200-landing/oth-blog-banner-bg.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      max-width: 330px;
      height: 395px;
      border-radius: 10px;
      padding: var(--spacing-90) 34px;
      text-align: center;

      .title {
        margin-bottom: 58px;

        > span {
          display: block;
        }
      }

      .first-line {
        color: var(--main-light);
        font-weight: 700;
        font-size: 34px;
        line-height: 110%;

        .highlighted {
          color: var(--extreme-yellow);
        }
      }

      .second-line {
        font-weight: 700;
        font-size: 26px;
        line-height: 110%;
        color: var(--extreme-fucsia);

        .highlighted {
          font-weight: 700;
          font-size: 26px;
        }
      }

      .third-line {
        color: var(--main-light);
        font-weight: 700;
        font-size: 31px;
      }

      .btn-one-of-two-hundred {
        width: calc(100% - 9px);
        height: 56px;
        font-weight: 600;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0.02em;
        cursor: pointer;
        color: var(--main-dark);
        background: var(--extreme-yellow);
        border-radius: 7px;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        transition-duration: 320ms;
        box-shadow:
          0 0 0 #B7B700,
          1px 1px 0 #B7B700,
          2px 2px 0 #B7B700,
          3px 3px 0 #B7B700,
          4px 4px 0 #B7B700,
          5px 5px 0 #B7B700,
          6px 6px 0 #B7B700,
          7px 7px 0 #B7B700,
          8px 8px 0 #B7B700,
          9px 9px 0 #B7B700;

          &:hover {
          color: var(--main-dark);
          background: #E7E700;
          box-shadow:
            0 0 0 #A7A700,
            1px 1px 0 #A7A700,
            2px 2px 0 #A7A700,
            3px 3px 0 #A7A700,
            4px 4px 0 #A7A700,
            5px 5px 0 #A7A700,
            6px 6px 0 #A7A700,
            7px 7px 0 #A7A700,
            8px 8px 0 #A7A700,
            9px 9px 0 #A7A700;
        }

        &:active {
          box-shadow: none;
          transition-duration: 50ms;
          transform: translate(9px, 9px);
        }
      }
    }

    .col-4 {
      padding-left: var(--spacing-40);
    }
  }

  .up-arrow-btn {
    background: var(--main-dark-shade-1);
    border-radius: 3px;
    color: var(--main-light);
    height: 56px;
    margin: 0 var(--spacing-48) var(--spacing-60) auto;
    padding: var(--spacing-12);
    position: sticky;
    text-align: center;
    width: 56px;
    transition: all var(--duration) ease-in;
    opacity: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-right: 125px;
    bottom: 54px;

    &.visible {
      opacity: 1;
    }

    svg {
      margin-bottom: 5px;

      path[stroke] {
        stroke: var(--main-light);
      }
    }

    &:hover {
      color: var(--main-light);
    }
  }
}

@include bp($bp-laptop) {
  .single-post-preview .blog-preview {
    h1 {
      font-size: 32px;
    }

    .one-of-two-hundred {
      padding: 93px var(--spacing-30);

      .title {
        margin-bottom: var(--spacing-28);
      }

      .first-line {
        line-height: 38px;
        font-size: 32px;
        margin-bottom: var(--spacing-8);
      }

      .second-line {
        line-height: 30px;
      }

      .third-line {
        line-height: 38px;
      }
    }

    .col-4 {
      padding-left: 15px;
    }
  }
}

@include bp($bp-mobile) {
  .single-post-preview {
    padding-top: var(--spacing-120);

    .blog-preview {
      .author-name {
        display: block;
        margin-bottom: var(--spacing-24);

        .team {
          margin-bottom: var(--spacing-16);
        }

        span.bullet {
          display: inline-block;
          vertical-align: middle;

          &:first-of-type {
            display: none;
          }
        }
      }

      .article-content {
        blockquote {
          padding: 70px var(--spacing-32) var(--spacing-32);
        }
      }

      .learn-bf {
        .campaign {
          font-size: 36px;
        }
      }

      .learn-cm {
        max-width: 330px;

        .bg-visual-1 {
          left: 42px;
        }
      }

      .got-what-it-takes {
        max-width: 100%;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .promo-subtitle {
          max-width: 290px;
          margin-left: auto;
          margin-right: auto;
        }

        .btn-got-what-it-takes {
          max-width: 270px;
        }

        @media screen and (max-width: 360px) {
          padding: 0 10px;

          .campaign-title {
            .highlighted-left {
              font-size: 13vw;
            }

            .highlighted-right {
              font-size: 15vw;
            }
          }

          .promo-subtitle {
            font-size: 7vw;
          }

          .promo-subtitle,
          .btn-got-what-it-takes {
            width: 100%;
          }
        }
      }

      .one-of-two-hundred {
        max-width: 100%;

        .btn-one-of-two-hundred {
          max-width: 310px;
          margin: 0 auto;
        }
      }

      .similar-posts {
        margin-top: var(--spacing-80);
      }
    }

    .up-arrow-btn {
      margin-left: var(--spacing-12);
      bottom: 34px;
    }
  }
}

@include bp($bp-phone) {
  .single-post-preview .blog-preview {
    .try-banner {
      margin-top: var(--spacing-80);
      padding: var(--spacing-36) var(--spacing-30);
      height: auto;
      min-height: 577px;
      background: var(--main-dark-shade-1);

      img {
        display: block;
        margin: 0 auto;
        width: 100%;
      }

      &:before {
        display: none;
      }

      .h4 {
        display: block;
        width: 100%;
        margin-bottom: var(--spacing-16);
        text-align: center;
      }

      p {
        text-align: center;
        color: var(--main-dark-shade-4);
        margin: 0 0 var(--spacing-36);
      }

      a {
        width: 100%;
        margin-top: var(--spacing-36);
      }

      .rating-holder {
        margin-top: var(--spacing-16);
        display: flex;
        flex-wrap: wrap;

        .rating {
          display: flex;
          margin-right: var(--spacing-12);
        }

        .text {
          color: var(--main-light);
          opacity: 0.67;
        }
      }
    }

    .one-of-two-hundred {
      padding: var(--spacing-90) var(--spacing-28);

      .title {
        margin-bottom: var(--spacing-28);
      }

      .first-line,
      .second-line {
        margin-bottom: var(--spacing-8);
      }

      .btn-one-of-two-hundred {
        width: 262px;
        margin: 0;
      }
    }
  }
}
</style>
